module.exports = __webpack_public_path__ + "img/game_2_2.8b567c59.png";